import { IContentCardItem } from '~/src/features/movix-new/ContentCard';

export const CARDS: IContentCardItem[] = [
    {
        title: 'Одним кабелем к любому телевизору',
        description: 'Просто подключаете кабель HDMI — и всё. Подходит к любым телевизорам, даже довольно старым.',
        img: 'static/images/movix-new/hdmi.png',
        imgWebp: 'static/images/movix-new/hdmi.webp',
        area: 'large',
    },
    {
        title: 'Без вреда вашему ремонту',
        description: 'Подключение к интернету по Wi-Fi — не нужно тянуть кабель через всю квартиру.',
        img: 'static/images/movix-new/router.png',
        imgWebp: 'static/images/movix-new/router.webp',
        area: 'first',
    },

    {
        title: 'Не мешая близким',
        description: 'Подключайте беспроводные наушники по Bluetooth и наслаждайтесь.',
        img: 'static/images/movix-new/airpods-pro.png',
        imgWebp: 'static/images/movix-new/airpods-pro.webp',
        area: 'second',
    },
    {
        title: 'Не ограничиваясь видео',
        description: 'Устанавливайте приложения из магазина как на Smart TV.',
        img: 'static/images/movix-new/grid.png',
        imgWebp: 'static/images/movix-new/grid.webp',
        area: 'third',
    },
];

